import Planning from "./planning";
import IPlanning from "../interface/planning";
import ICardPlanning from "../interface/card-planning";
import Global from "../global";
import ErrorCode from "../enum/error-code";
import CardType from "../enum/card-type";
import ModuleCardBase from "../class/module-card-base";

class ModuleCardPlanningInstance extends ModuleCardBase {

    public CardType: CardType = CardType.Planning;

    public async onCreate(card: ICardPlanning): Promise<ICardPlanning> {
        if (card.planning) {
            const planning: IPlanning = await Planning.create(card.planning);
            card.label = planning.name;
            card.icon = Global.DEFAULT_PLANNING_ICON;
            card.planningId = planning.id as number;
            return card;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async onDelete(card: ICardPlanning): Promise<void> {
        await Planning.delete(card.planningId, false);
    }

    public async onClone(card: ICardPlanning): Promise<ICardPlanning> {
        const planning: IPlanning = await Planning.clone(card.planningId) as IPlanning;
        card.planningId = planning.id as number;
        return card;
    }

    public toClient(card: ICardPlanning): ICardPlanning | null {
        const planning: IPlanning | null = Planning.get(card.planningId);
        if (planning) {
            card.label = planning.name;
            card.planning = planning;
            return card;
        }
        return null;
    }

    public toServer(card: ICardPlanning): ICardPlanning {
        return {
            id: card.id,
            type: CardType.Planning,
            label: card.label,
            moduleId: card.moduleId,
            icon: Global.DEFAULT_PLANNING_ICON,
            planningId: card.planningId
        };
    }

    public valid(card: ICardPlanning): boolean {
        return !!card.planning;
    }

}

const ModuleCardPlanning = new ModuleCardPlanningInstance();

export default ModuleCardPlanning;